import React, { useState, useEffect } from 'react';
import { useSnackbar } from 'notistack';

import CreatePushNotification from './components/CreatePushNotification';
import campaignsAPI from '../../../apis/campaigns';

const CreatePushNotificationContainer = () => {
  const { enqueueSnackbar } = useSnackbar();
  const [isLoading, setLoading] = useState(false);
  const [createError, setCreateError] = useState(null);
  const [appDeepLinks, setAppDeepLinks] = useState(null);

  useEffect(() => {
    const fetchAppDeepLinks = async () => {
      try {
        const appDeepLinksResponse = await campaignsAPI.getAppDeepLinks();
        setAppDeepLinks(appDeepLinksResponse.data?.data);
      } catch (error) {
        enqueueSnackbar(error.message, { variant: 'error' });
      }
    };

    fetchAppDeepLinks();
  }, [enqueueSnackbar]);

  const handleSubmit = async (payload) => {
    try {
      const formData = new FormData();
      formData.append('type', 'push_notification');
      Object.keys(payload).forEach(fieldName => {
        formData.append(fieldName, payload[fieldName]);
      });

      setLoading(true);
      const response = await campaignsAPI.createCampaign(formData);
      if (response) {
        enqueueSnackbar('Campaign created successfully!', { variant: 'success' });
      }
    } catch (error) {
      enqueueSnackbar(error.message, { variant: 'error' });
      setCreateError(error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <CreatePushNotification
      onSubmit={handleSubmit}
      error={createError}
      isCreating={isLoading}
      appDeepLinks={appDeepLinks}
    />
  );
};

export default CreatePushNotificationContainer;
